import React, { createContext, useState } from 'react';

export const UserContext = createContext();

export default function UserProvider(props) {

    const [userDetails, setUserDetails] = useState({
        name: '',
        email: '',
        username:'',
        role: '',
        savedProperties: [],
        image: '',
        notification: true,
        _id:''
    });

    const [isLoggedIn, setIsLoggedIn] = useState(false);

    const [isLoding, setLoading] = useState(true);

    return (
        <UserContext.Provider value={{
            userDetails,
            setUserDetails,
            isLoggedIn,
            setIsLoggedIn,
            isLoding,
            setLoading
        }}>
            {props.children}
        </UserContext.Provider>
    )

}